import { Link } from "react-router-dom";
import { LEARNER_LICENSE_CONTACT_EMAIL } from "../../constants";

export const InviteSupportLink = () => (
  <Link
    className="underline underline-offset-2 hover:text-dm-brand-blue-800/80 hover:no-underline"
    to={`mailto:${LEARNER_LICENSE_CONTACT_EMAIL}`}
  >
    {LEARNER_LICENSE_CONTACT_EMAIL}
  </Link>
);
